import type { IControlSectionCard } from './SectionCard';

import { REPORT_FILTER_STICKY_ID, REPORT_FILTER_STICKY_TOP } from '~/modules/report-analytic';
import { GroupedSelectPopover } from '../../GroupedSelectPopover';
import { Button, InlineStack, Text } from '@shopify/polaris';
import { PlusIcon } from '@shopify/polaris-icons';
import { useToggle } from '~/hooks/useToggle';
import { useIsStickyById } from '~/hooks';

export const SectionCardContent: React.FC<IControlSectionCard> = (props) => {
  const { label, config } = props;

  const { value: popoverActive, toggle: togglePopoverActive } = useToggle(false);
  const isSticky = useIsStickyById({
    id: REPORT_FILTER_STICKY_ID,
    stickyTop: REPORT_FILTER_STICKY_TOP,
  });

  if (!config) {
    return (
      <Text as="p" variant="headingSm">
        {label}
      </Text>
    );
  }

  return (
    <GroupedSelectPopover
      {...props}
      activator={
        <div className="cursor-pointer" onClick={togglePopoverActive}>
          <InlineStack align="space-between" blockAlign="center">
            <Text as="p" variant="headingSm">
              {label}
            </Text>
            <Button variant="tertiary" size="micro" icon={PlusIcon} {...config} />
          </InlineStack>
        </div>
      }
      fixed={isSticky}
      popoverActive={popoverActive}
      togglePopoverActive={togglePopoverActive}
      variant="choice"
    />
  );
};
